import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type PagingContext = {
  // Server-provided paging info
  currentPage?: number | null;
  totalPage?: number | null;
  hasNext?: boolean | null;
  hasPrevious?: boolean | null;
  pageSize?: number | null;
  infoPagination?: string | null;
  // Additional context we want to persist
  filters?: Record<string, any> | null;
  sessionId?: string | null;
  // The last user query that produced the list
  lastQuery?: string | null;
};

interface AgentState {
  // Holds the most recent paging context for resource_list
  pagingContext: PagingContext | null;
  setPagingContext: (context: PagingContext | null) => void;
  clearPagingContext: () => void;
}

const initialState: AgentState = {
  pagingContext: null,
  setPagingContext: () => {},
  clearPagingContext: () => {},
};

export const useAgentStore = create<AgentState>()(
  devtools(
    (set) => ({
      ...initialState,
      setPagingContext: (context) => set({ pagingContext: context }, false, "setPagingContext"),
      clearPagingContext: () => set({ pagingContext: null }, false, "clearPagingContext"),
    }),
    { name: "agent-store" }
  )
);
